<template>
  <div id="pls-car-container"
       :class="['container-fluid', brandClass, 'mt-3', 'mt-md-5', 'pt-5', 'pt-md-7', 'pb-5', 'md-mb-0', 'mb-6', 'crc-home-module']">
    <div class="crc-car-selection-container d-flex flex-column">
      <div class="row gx-3">
        <div class="col-12">
          <h2 id="pls-title" class="text-center">{{ title }}</h2>
          <div v-if="carStore.loading && carStore.filteredCars.length === 0">
            <h5 id="pls-subtitle" class="text-center mt-0">{{ subtitle }}</h5>
            <div class="row crc-reffer-cards mt-3">
              <div v-for="n in skeletonCount"
                   :key="n"
                   :class="['col-sm-6', layoutColumns, 'mt-0', 'mt-sm-0', 'd-flex', 'flex-column']">
                <skeleton-car-card />
              </div>
            </div>
          </div>
          <div v-else-if="carStore.filteredCars.length === 0">
            <h3 class="fw-bold text-center mt-0">Er zijn geen auto's beschikbaar.</h3>
          </div>
          <div v-else>
            <h5 id="pls-subtitle" class="text-center mt-0">{{ subtitle }}</h5>
            <div class="row crc-reffer-cards mt-3">
              <div id="pls-car-column"
                   v-for="car in carStore.filteredCars"
                   :key="car.id"
                   :class="['col-sm-6', layoutColumns, 'mt-0', 'mt-sm-0', 'd-flex', 'flex-column', 'cursor-pointer']">
                    <car-card :car="car" :cta-text="ctatext" :brand-class="brandClass" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCarStore } from "@/stores/car";
import CarCard from '@/components/CarCard.vue'
import SkeletonCarCard from '@/components/SkeletonCarCard.vue'
import {inject} from "vue";

export default {
  name: 'HomeModule',
  components: {
    CarCard,
    SkeletonCarCard
  },
  data() {
    return {
      carStore: useCarStore(),
      title: '',
      subtitle: '',
      ctatext: '',
      layoutColumns: 3,
      brandClass: 'renault',
      plsContext: inject('plsContext'),
    }
  },
  computed: {
    filteredCars() {

      return this.carStore.filteredCars;
    },
    skeletonCount() {
      const numCars = parseInt(this.carStore.context?.el?.getAttribute('data-pls-num-cars'), 10);
      return isNaN(numCars) ? 4 : numCars;
    }
  },
  methods: {
    async fetchCars(forceUpdate = false) {
      await this.carStore.fetchCars(forceUpdate);

    },
    getPlsCookie(name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    },
  },
   mounted() {

    this.fetchCars();
    const defaultBrand = 'renault';
    const brandCookie = this.getPlsCookie('nieuwendijk-switch');
    const brandMap = {
     undefined: defaultBrand,
     none: defaultBrand,
     dacia: 'dacia',
     renault: defaultBrand
    };

    this.brandClass = brandMap[brandCookie] || defaultBrand;

    const title = this.plsContext?.title;
    const subtitle = this.plsContext?.subtitle;
    const ctatext = this.plsContext?.btnText;
    const plsCols = this.plsContext?.layoutCols;

    this.layoutColumns = `col-lg-${plsCols}`;
    // Make the title and subtitle dynamic
    this.title = title ? title : '';
    this.subtitle = subtitle ? subtitle : '';
    this.ctatext = ctatext ? ctatext : '';
  },
}
</script>


